<div class="w-100">
    @if (showLoader) {
<app-loader></app-loader>
}
    <ejs-grid
        #proposalGrid
        [dataSource]="dataSource"
        [allowPaging]="true"
        [pageSettings]="{ pageSizes: [20, 50, 100, 500], pageSize: 20 }"
        [gridLines]="false"
        [allowFiltering]="true"
        [showColumnChooser]="true"
        [height]="gridHeight"
        [allowSorting]="true"
        [enableHover]="false"
        [allowResizing]="true"
        [allowReordering]="true"
        [allowExcelExport]="true"
        [allowSelection]="true"
        [searchSettings]="searchSettings"
        [sortSettings]="sortOptions"
        [editSettings]="{ allowEditing: false }"
        [filterSettings]="{ type: 'Menu' }"
        (toolbarClick)="onToolbarClick($event)"
        (rowDataBound)="onRowDataBound($event)"
        (commandClick)="commandClick($event, proposalGrid)"
        (created)="created()"
        (actionComplete)="onGridActionComplete($event, proposalGrid)"
        >
        <e-columns>
            @for (column of columns; track column) {
<e-column
               
                [field]="column.field"
                [headerText]="column.headerText"
                [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
                [type]="column.type"
                [width]="column.width"
                [filter]="column.filter ? column.filter : { type: 'Menu' }"
                [format]="column.format ? column.format : null"
                [textAlign]="column.textAlign"
                [showInColumnChooser]="column.showInColumnChooser"
                [visible]="column.visible"
                [commands]="column?.commands ? column.commands : null"
                [edit]="column.edit"
                [allowReordering]="column.allowReordering ?? true"
                [freeze]="column.freeze ? column.freeze: null"
                [allowEditing]="column.allowEditing"
                [allowSorting]="column.allowSorting ?? true"
                [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">
                @if (column.field === 'statusText') {
<ng-template #template let-data>
                  <span class="grid-status-column" [ngStyle]="{'background-color': data.statusColorCode}">{{data.statusText}}</span>
                </ng-template>
}
                @if (column.field === 'proposalId') {
<ng-template #template let-data>
                  <i class="fas" [ngClass]="{ 'fa-circle-check color-green': data.isActive, 'fa-ban color-red': !data.isActive }" [title]="data.isActive ? 'Active': 'Inactive'"></i>
                  <a href="javascript:" (click)="openProposalPopup(null, null, data.proposalId)">
                    {{ data.proposalId }}
                  </a>
                </ng-template>
}
                @if (column.field === 'businessPartner') {
<ng-template #template let-data>
                  <a href="javascript:" (click)="onBPIdClick(data.soldToBP)">{{data.businessPartner}}</a>
                </ng-template>
}
                @if (column.field === 'customer') {
<ng-template #template let-data>
                  <a href="javascript:" (click)="openProspectPopup(data.customerId)">{{data.customer}}</a>
                </ng-template>
}
                @if (column.field === 'salesLeadId') {
<ng-template #template let-data>
                  <a href="javascript:" (click)="openLeadsPopup(data.salesLeadId)">{{data.salesLeadId}}</a>
                </ng-template>
}
                @if (column.field === 'accountName') {
<ng-template #template let-data>
                  @if (data.accountName) {
<a href="javascript:" (click)="openDistributorPopup(data)">{{data.accountName}}</a>
}
                </ng-template>
}
            </e-column>
}
        </e-columns>
    </ejs-grid>
  </div>

  <ng-template #columnChooser>
    <app-column-chooser
        [grid]="grid"
    ></app-column-chooser>
  </ng-template>

  <ng-template #addLeads>
    @if (rolePermissions['proposalGrid_add']?.visible) {
<i class="fas fa-add"></i>
}
  </ng-template>

  @if (showProspectsPopup) {
<app-prospects-popup
 
    [prospectData]="prospectData"
    [tab]="'details'"
    (onClose)="showProspectsPopup = false"
    >
  </app-prospects-popup>
}
